import * as React from 'react';
import styled from 'styled-components';
import Loading from '../../../commonComponents/Loading';
import { sendForgottenPasswordEmail } from '../../../core/api';
import FormView from '../../common/FormView';
import AnonymousLayout from '../../layouts/AnonymousLayout';
import Fieldset from '../../../commonComponents/fields/Fieldset';
import AsyncForm, { AsyncFormState } from '../../../commonComponents/forms/AsyncForm';
import EmailField from '../../../commonComponents/fields/EmailField';
import { Logo } from '../../../models/be/Branding';
import { getBrandingLogo } from '../../../core/customer';
import { getUniqueQueryString } from '../../../lib/utils';
import './ForgotPassword.less';

export default class ForgotPassword extends AsyncForm<unknown, State> {
	constructor(props: undefined) {
		super(props);
		const prefillEmail = getUniqueQueryString(window.location.search, 'email');
		this.state = {
			isValid: !!prefillEmail,
			fieldsValidation: {},
			emailAddress: prefillEmail || '',
			emailSent: false,
			errorMessage: null,
			loading: false,
			logo: null
		};
	}

	componentDidMount() {
		this.getWebsiteLogo();
	}

	getWebsiteLogo = async () => {
		this.setState({ loading: true });
		const brandingLogo = await getBrandingLogo();
		this.setState({ logo: brandingLogo });
		this.setState({ loading: false });
	};

	handleFormSubmit = async () => {
		if (!this.state.isValid) {
			return;
		}

		await this.performAction(async () => {
			await sendForgottenPasswordEmail(this.state.emailAddress, false);
			this.setState({ emailSent: true });
		});
	};

	render() {
		return (
			<AnonymousLayout title="Forgot Password?" logo={this.state.logo}>
				<FormView
					className="forgotPassword"
					onFormSubmit={this.handleFormSubmit}
					submitButtonText="Submit"
					isSubmitButtonVisible={!this.state.emailSent}
					errorMessage={this.state.errorMessage}
				>
					<Fieldset title="Forgot Password?" centred>
						{this.state.emailSent ? (
							<Text>
								Valid account email addresses will receive an email in the next 5 minutes with a password reset link.
								Please ensure you use the most recent email link if you have used this form before.
							</Text>
						) : (
							<>
								<Text>Submit your email address here.</Text>
								<EmailField
									label="Email"
									name="emailAddress"
									value={this.state.emailAddress}
									onValueChange={this.handleValueChange}
									autoFocus
								/>
							</>
						)}
						{this.state.loading && <Loading />}
					</Fieldset>
				</FormView>
			</AnonymousLayout>
		);
	}
}

interface State extends AsyncFormState {
	emailAddress: string;
	emailSent: boolean;
	logo?: Logo;
}

const Text = styled.p`
	margin-top: 25px;
`;
